/**
 * Zentrales Permission-Registry
 * 
 * SINGLE SOURCE OF TRUTH fuer alle Berechtigungen.
 * Auto-Sync: Sidebar-Items werden automatisch aus navigation.js generiert.
 * 
 * LABELS muessen EXAKT dem UI-Text entsprechen!
 */
import { NAV_ITEMS } from './navigation';

// Auto-generate sidebar permissions from navigation config
const getSidebarPermissions = () => {
    return NAV_ITEMS
        .filter(item => item.permission)
        .map(item => ({
            key: item.permission,
            label: item.label
        }));
};

export const PERMISSION_REGISTRY = [
    {
        id: 'sidebar',
        title: 'Sidebar / Navigation',
        description: 'Sichtbarkeit der Menuepunkte (automatisch aus Navigation)',
        autoSync: true,
        perms: getSidebarPermissions()
    },
    {
        id: 'events',
        title: 'Kalender & Termine',
        description: 'Termine erstellen, bearbeiten, Spielberichte',
        perms: [
            { key: 'create_event', label: 'Termin erstellen' },
            { key: 'create_cost_split', label: 'Kosten-Split-Termin erstellen' },
            { key: 'manage_events', label: 'Alle Termine bearbeiten & loeschen' },
            { key: 'view_game_reports', label: 'Tab: "Spielbericht" (im Termin-Detail)' },
            { key: 'view_calendar_warnings', label: 'Kalender-Warnungen anzeigen (Konflikte/Abhängigkeiten)' },
            { key: 'view_child_team_events', label: 'Kinder-Team-Termine sehen (Eltern)' },
            { key: 'carpool_on_behalf_children', label: 'Fahrgemeinschaften im Namen von Kindern verwalten' },
            { key: 'manage_carpooling', label: 'Fahrangebote/Gesuche anderer verwalten' },
            { key: 'manage_ical_global_content', label: 'iCal: Geburtstage/Jubiläen einschließen' },
        ]
    },
    {
        id: 'services',
        title: 'Dienstplaner',
        description: 'Dienste, Helfer, Auswertungen, oeffentliche Links',
        perms: [
            { key: 'create_service', label: 'Dienst erstellen' },
            { key: 'manage_services', label: 'Dienste global verwalten (Bearbeiten/Loeschen)' },
            { key: 'view_service_list', label: 'Tab: "Dienste"' },
            { key: 'view_service_reports', label: 'Tab: "Auswertung"' },
            { key: 'view_public_service_links', label: 'Tab: "Oeffentliche Links"' },
            { key: 'manage_public_service_links', label: 'Oeffentliche Links erstellen & loeschen' },
            { key: 'export_service_pdf', label: 'Button: PDF-Export' },
            { key: 'assign_service_helpers', label: 'Helfer zuweisen & entfernen' },
            { key: 'configure_service_custom_fields', label: 'Benutzerdefinierte Felder konfigurieren' },
            { key: 'view_own_helper_hours', label: 'Eigene Helferstunden im Profil sehen' },
        ]
    },
    {
        id: 'tasks',
        title: 'Massnahmen & Aufgaben',
        description: 'Massnahmen erstellen, bearbeiten, zuweisen',
        perms: [
            { key: 'create_task', label: 'Massnahme erstellen' },
            { key: 'edit_task', label: 'Eigene Massnahmen bearbeiten' },
            { key: 'delete_task', label: 'Eigene Massnahmen loeschen' },
            { key: 'manage_all_tasks', label: 'Alle Massnahmen verwalten' },
        ]
    },
    {
        id: 'resources',
        title: 'Ressourcen & Buchungen',
        description: 'Plaetze, Raeume und Anlagen buchen und verwalten',
        perms: [
            { key: 'create_booking', label: 'Direkt buchen (ohne Anfrage)' },
            { key: 'create_booking_request', label: 'Buchungsanfrage erstellen' },
            { key: 'view_booking_dashboard', label: 'Tab: "Dashboard"' },
            { key: 'view_booking_requests', label: 'Tab: "Anfragen"' },
            { key: 'submit_booking_request', label: 'Trainingsanfragen erstellen' },
            { key: 'create_training_request', label: 'Trainingsanfrage senden' },
            { key: 'manage_booking_deadline', label: 'Anfrage-Deadline verwalten' },
            { key: 'view_allocation_tab', label: 'Zuweisung/Verteilung ansehen' },
            { key: 'create_extra_booking', label: 'Fremde Buchungen erstellen' },
            { key: 'view_slot_exchange', label: 'Tab: "Tauschboerse"' },
            { key: 'view_resource_settings', label: 'Tab: "Verwaltung"' },
            { key: 'assign_booking_requests', label: 'Buchungen genehmigen' },
            { key: 'edit_booking', label: 'Eigene Buchungen bearbeiten' },
            { key: 'edit_all_bookings', label: 'Alle Buchungen bearbeiten' },
            { key: 'delete_booking', label: 'Eigene Buchungen stornieren' },
            { key: 'manage_all_bookings', label: 'Alle Buchungen verwalten & loeschen' },
            { key: 'manage_resources', label: 'Ressourcen verwalten' },
            { key: 'manage_court_blocks', label: 'Plätze/Zonen sperren (Platzpflege)' },
            { key: 'manage_event_buffers', label: 'Feste Slots verwalten' },
            { key: 'search_free_resources', label: 'Freie Slots suchen' },
            { key: 'export_resource_pdf', label: 'Button: "Belegungsplan PDF"' },
            { key: 'print_resources', label: 'Button: "Drucken"' },
        ]
    },
    {
        id: 'documents',
        title: 'Dokumentenablage',
        description: 'Ordner, Dokumente, Links und Zugriffsrechte',
        perms: [
            { key: 'view_documents', label: 'Dokumentenablage anzeigen' },
            { key: 'upload_documents', label: 'Dokumente/Links hochladen & Ordner anlegen' },
            { key: 'manage_documents', label: 'Alle Dokumente global verwalten' },
            { key: 'manage_document_settings', label: 'Uploader-Regeln verwalten' },
        ]
    },
    {
        id: 'teams',
        title: 'Teams',
        description: 'Team-Tabs fuer Verantwortliche (Trainer/Betreuer)',
        perms: [
            { key: 'manage_teams', label: 'Teams erstellen, bearbeiten & loeschen' },
            { key: 'view_team_roster', label: 'Tab: "Kader & Info"' },
            { key: 'view_team_tactics', label: 'Tab: "Taktikboard"' },
            { key: 'view_player_stats', label: 'Tab: "Spieler-Statistik"' },
            { key: 'view_team_stats', label: 'Tab: "Team-Statistik"' },
            { key: 'view_team_treasury', label: 'Tab: "Mannschaftskasse"' },
            { key: 'reset_team_stats', label: 'Team-Statistiken vollständig zurücksetzen' },
        ]
    },
    {
        id: 'meetings',
        title: 'Sitzungen & Gremien',
        description: 'Sitzungen, Protokolle und Gremien verwalten',
        perms: [
            { key: 'view_meetings_overview_tab', label: 'Sitzungen-Tab: "Übersicht"' },
            { key: 'view_meetings_committees_tab', label: 'Sitzungen-Tab: "Gremien"' },
            { key: 'manage_meetings', label: 'Sitzungen anderer bearbeiten/löschen' },
            { key: 'manage_committees', label: 'Gremien erstellen, bearbeiten & löschen' },
        ]
    },
    {
        id: 'tournaments',
        title: 'Turniere',
        description: 'Turniere planen, verwalten, Ergebnisse pflegen',
        perms: [
            { key: 'create_tournament', label: 'Neues Turnier erstellen' },
            { key: 'edit_tournament', label: 'Turnier bearbeiten & speichern' },
            { key: 'manage_tournament', label: 'Turniere loeschen (Vollzugriff)' },
            { key: 'manage_tournament_categories', label: 'Tab: "Kategorien" verwalten' },
            { key: 'manage_tournament_banner', label: 'Tab: "Banner" verwalten' },
            { key: 'view_tournament_list', label: 'Tab: "Liste"' },
            { key: 'view_tournament_calendar', label: 'Tab: "Kalender"' },
            { key: 'view_tournament_results_service', label: 'Tab: "Ergebnis-Dienst"' },
            { key: 'view_category_registrations', label: 'Tab: "Anmeldungen"' },
            { key: 'view_tournament_revenue', label: 'Tab: "Umsatz"' },
            { key: 'manage_tournament_revenue', label: 'Umsatz-Einträge erstellen/bearbeiten/löschen' },
            { key: 'view_tournament_live_pages', label: 'Tab: "Live"' },
            { key: 'manage_tournament_live_pages', label: 'Live-Seiten erstellen/bearbeiten/löschen' },
            { key: 'view_tournament_multi_registration', label: 'Tab: "Sammel-Anmeldung"' },
        ]
    },
    {
        id: 'facility',
        title: 'Inventar & Maengel',
        description: 'Anlagen, Inventar und Maengelberichte',
        perms: [
            { key: 'view_inventory', label: 'Inventar anzeigen' },
            { key: 'view_defects', label: 'Maengel anzeigen' },
            { key: 'create_defect', label: 'Mangel melden' },
            { key: 'manage_defects', label: 'Maengel bearbeiten, Status aendern & loeschen' },
            { key: 'manage_inventory', label: 'Inventar verwalten' },
            { key: 'manage_facility_categories', label: 'Kategorien verwalten' },
        ]
    },
    {
        id: 'addressbook',
        title: 'Adressbuch',
        description: 'Kontakte und Kategorien verwalten',
        perms: [
            { key: 'create_contact', label: 'Neuen Kontakt anlegen' },
            { key: 'edit_contact', label: 'Kontakte bearbeiten' },
            { key: 'delete_contact', label: 'Kontakte loeschen' },
            { key: 'create_addressbook_category', label: 'Neue Kategorie erstellen' },
            { key: 'edit_addressbook_category', label: 'Kategorien bearbeiten' },
            { key: 'delete_addressbook_category', label: 'Kategorien loeschen' },
        ]
    },
    {
        id: 'invitations',
        title: 'Einladungen',
        description: 'Einladungen an neue Mitglieder versenden',
        perms: [
            { key: 'send_invitations', label: 'Einladung versenden' },
            { key: 'view_invitation_history', label: 'Tab: "Einladungsverlauf"' },
            { key: 'delete_invitation', label: 'Einladungen loeschen' },
        ]
    },
    {
        id: 'news',
        title: 'News & Live-Ticker',
        description: 'Neuigkeiten und Live-Ergebnisse',
        perms: [
            { key: 'manage_news', label: 'News erstellen & verwalten' },
            { key: 'manage_ticker', label: 'Ticker-Spiele erstellen & verwalten' },
        ]
    },
    {
        id: 'chat',
        title: 'Chat & Benachrichtigungen',
        description: 'Kanäle verwalten und Vereinsdurchsagen senden',
        perms: [
            { key: 'manage_chat_channels', label: 'Chat-Kanäle erstellen/bearbeiten/löschen' },
            { key: 'send_announcements', label: 'Durchsagen an Rollen/Teams senden' },
        ]
    },
    {
        id: 'admin',
        title: 'Verwaltung & System',
        description: 'Benutzer, Einstellungen und Sponsoren',
        perms: [
            { key: 'manage_users', label: 'Tab: "Mitglieder" verwalten' },
            { key: 'approve_registrations', label: 'Neuanmeldungen freigeben/ablehnen' },
            { key: 'manage_settings', label: 'App-Einstellungen aendern' },
            { key: 'manage_roles', label: 'Rollen & Rechte konfigurieren' },
            { key: 'view_sponsors', label: 'Tab: "Sponsoren" verwalten' },
        ]
    },
];

// Collect ALL permission keys for validation
const _allKeys = new Set();
PERMISSION_REGISTRY.forEach(group => {
    group.perms.forEach(p => {
        if (p.key) _allKeys.add(p.key);
    });
});

// Helper: Get all unique permission keys
export const getAllPermissionKeys = () => Array.from(_allKeys);

// Helper: Count total permissions
export const getTotalPermissionCount = () => _allKeys.size;

// Helper: Count active permissions for a role
export const getActivePermissionCount = (rolePermissions, role) => {
    return (rolePermissions[role] || []).length;
};

// Validation: Check if a permission key exists in the registry
export const validatePermissionKey = (key) => {
    if (!_allKeys.has(key)) {
        console.warn(`[Permission Registry] Unbekannter Permission-Key: "${key}" — bitte in permissionRegistry.js eintragen!`);
        return false;
    }
    return true;
};
